import { render, staticRenderFns } from "./tab-header.vue?vue&type=template&id=012b093c&scoped=true"
import script from "./tab-header.vue?vue&type=script&lang=js"
export * from "./tab-header.vue?vue&type=script&lang=js"
import style0 from "./tab-header.vue?vue&type=style&index=0&id=012b093c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012b093c",
  null
  
)

export default component.exports